var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

const addToCartForm = document.querySelector(".product-form");
const out_stock = document.querySelectorAll(".out-of-stock-products");
const out_stock_message = document.querySelector(".product-form-out");

let addToCartButton = document.querySelector(".addtocart");
let selectedVariant = document.querySelector(".product-page-cart-input");
let formID = document.querySelector(".product-form-new-product-template");
let featuredImage = document.querySelector(".product-hero__product img");
let priceForProduct = document.querySelector("#ProductPrice-CalculatePrice");

let out_of_stock_ids = [];
out_stock.forEach((item) => {
  if (!item) return;
  out_of_stock_ids.push(item.innerText);
});
/**
 * Set active swatch
 *
 * @return  {void}
 */

/**
 * Update the product page content after swatch change.
 *
 * @return  {void}
 */
const updateProductPage = () => {
  const swatch = document.querySelector(
    ".current-swatch .product-swatch.active"
  );
  if (swatch.classList.contains("product-swatch--all-products")) return;

  const productID =
    swatch && swatch.closest(".product-swatch").getAttribute("data-id");
  const productVariant =
    swatch && swatch.closest(".product-swatch").getAttribute("data-variant");
  const productImage = swatch && swatch.getAttribute("data-image");
  const productPrice =
    swatch && swatch.closest(".product-swatch").getAttribute("data-price");
  const productFlavor =
    swatch && swatch.closest(".product-swatch").getAttribute("data-title");
  const productHandle =
    swatch && swatch.closest(".product-swatch").getAttribute("data-handle");
  const productLink =
    swatch && swatch.closest(".product-swatch").getAttribute("data-link");
  const handleVariantChange = [addToCartButton, selectedVariant];

  if (out_of_stock_ids && out_stock_message) {
    const isOutOfStock = out_of_stock_ids.some((id) => id === productID);
    if (isOutOfStock) {
      out_stock_message.classList.remove("hide");
      formID.classList.add("hide");
    } else {
      out_stock_message.classList.add("hide");
      formID.classList.remove("hide");
    }
  }

  handleVariantChange.forEach((new_variant) => {
    if (!new_variant) return;
    new_variant.setAttribute("data-id", productVariant);
    new_variant.setAttribute("data-price", productPrice);
    new_variant.setAttribute(
      "data-img",
      productImage ? productImage : swatch.src
    );
    new_variant.setAttribute("data-name", productFlavor);
    new_variant.setAttribute("data-handle", productHandle);
    new_variant.setAttribute("data-link", productLink);
    new_variant.setAttribute("name", `updates[${productVariant}]`);
  });

  priceForProduct.innerText = Shopify.formatMoney(
    parseInt(productPrice)
  ).replace(".00", "");
  formID && formID.setAttribute("id", `product_form_${productID}`);
};

const updateProductPageWithFetch = () => {
  const swatch = document.querySelector(
    ".current-swatch .product-swatch.active"
  );
  const productContainer = swatch.closest(".product__info-container");
  
  const productID =
    swatch && swatch.closest(".product-swatch").getAttribute("data-id");
  const productVariant =
    swatch && swatch.closest(".product-swatch").getAttribute("data-variant");
  const productImage = swatch && swatch.getAttribute("data-image");
  const productPrice =
    swatch && swatch.closest(".product-swatch").getAttribute("data-price");
  const productFlavor =
    swatch && swatch.closest(".product-swatch").getAttribute("data-title");
  const productHandle =
    swatch && swatch.closest(".product-swatch").getAttribute("data-handle");
  const productLink =
    swatch && swatch.closest(".product-swatch").getAttribute("data-link");
  const handleVariantChange = [addToCartButton, selectedVariant];

  document.querySelector('.estimated-delivery-panel').classList.remove('d-none');
  productContainer.querySelector(".product__view-details").href = productLink;

  fetch(`${window.location.origin}/products/${productHandle}?section_id=card-product-wrapper`)
  .then(function (response) {
    return response.text(); /*usualy this is .json()*/
  })
  .then(function (data) {
    //var new_html = new DOMParser().parseFromString(data.body, "text/html").querySelector("body").innerHTML;
    var new_html = new DOMParser().parseFromString(data, "text/html").querySelector("body section#shopify-section-card-product-wrapper").innerHTML;
    productContainer.querySelector(".fetched-item-wrapper").innerHTML = new_html;

    /* add event listeners*/
    productContainer.querySelector(".fetched-item-wrapper")
      .querySelectorAll("input.quantity-detector")
      .forEach(function (element) {
        if (typeof window.wonderfulBindQuantityDetectorInput === "function") {
          window.wonderfulBindQuantityDetectorInput(element);
        }
      });
    productContainer.querySelector(".fetched-item-wrapper")
      .querySelectorAll(".input__number-holder")
      .forEach(function (element) {
        var clickElement = element.querySelectorAll(".qty");

        clickElement.forEach(function (element) {
          element.addEventListener("click", quantityOnClick);
        });
      });

  });

  if(swatch.classList.contains('unavailable')) {
    document.querySelector('.estimated-delivery-panel').classList.add('d-none');
  }
  
}

const initial_active = () => {
  document.getElementsByClassName("product-swatch")[0].classList.add('active');
  if(document.getElementsByClassName("product-swatch")[0].classList.contains('fetch-item-grid')){
    updateProductPageWithFetch();
  }
  else {
    updateProductPage();
  }
};

document.querySelectorAll(".product-swatch").forEach((swatch) => {
  if (!swatch) return;
  swatch.addEventListener("click", (e) => {
    const swatches = document.querySelectorAll(".product-swatch");

    swatches.forEach((swatch_element) => {
      swatch_element.classList.remove('active');
    })

    e.target.closest('.product-swatch').classList.add('active');

    if(swatch.classList.contains('fetch-item-grid')){
      updateProductPageWithFetch();
    }
    else {
      updateProductPage();
    }
  });
});

/**
 * Add to cart
 *
 * @return  {void}
 */
addToCartForm &&
  addToCartForm.addEventListener("submit", async (e) => {
    e.preventDefault();

    const qty = document.querySelector("#Quantity").value;
    const items = await fetchCart();
    if (addToCartButton) {
      const name = addToCartButton.getAttribute("data-name");
      const handle = addToCartButton.getAttribute("data-handle");
      const id = addToCartButton.getAttribute("data-id");
      const link = addToCartButton.getAttribute("data-link");
      const img = addToCartButton.getAttribute("data-img");
      const price = addToCartButton.getAttribute("data-price");
      const category = addToCartButton.getAttribute("data-category");
      const updateQuantity = items.find((item) => item.id === parseInt(id));
      const item_quantity = updateQuantity
        ? parseInt(qty) + updateQuantity.quantity
        : parseInt(qty);

      const item = {
        productTitle: name,
        productHandle: handle,
        productId: id,
        productCount: item_quantity,
        productLink: link,
        productImage: img,
        productPriceWithoutСurrency: parseInt(price) * parseInt(item_quantity),
        productPrice: Shopify.formatMoney(
          parseInt(price) * parseInt(item_quantity)
        ).replace(".00", ""),
        productCategory: category,
        itemAnimation: false,
        openCartDrawer: true,
        ajaxQuery: true,
      };

      cartDrawer.addToDrawer(item);
    }
  });

/**
 * Fetch cart
 *
 * @return  {Array}
 */
const fetchCart = async () => {
  try {
    const response = await fetch("/cart.js");
    const data = await response.json();
    return data && data.items;
  } catch (err) {
    console.error(err);
  }
};

initial_active();
